import React, { useState } from 'react'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuGroup,
  MenuOptionGroup,
  MenuItemOption,
} from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'

const MultiSelectMenu = ({
  label,
  options,
  onChange,
}: MultiSelectMenuProps): JSX.Element => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        color="gray.700"
        border="solid 0.5px"
        borderRadius="5px"
        borderColor={selectedOptions.length ? 'appBlue' : '#ced1d6'}
        minW="250px"
        minH="35px"
        textAlign="start"
        paddingLeft={4}
      >
        {`${label}${
          selectedOptions.length > 0 ? ` (${selectedOptions.length})` : ''
        }`}
        <ChevronDownIcon />
      </MenuButton>
      <MenuList minW="250px" maxH="350px" overflow="scroll">
        <MenuGroup>
          <MenuItem
            onClick={() => {
              setSelectedOptions([])
              onChange?.([])
            }}
          >
            Clear all
          </MenuItem>
        </MenuGroup>
        <MenuDivider />
        <MenuOptionGroup
          value={selectedOptions}
          type="checkbox"
          onChange={values => {
            if (Array.isArray(values)) {
              setSelectedOptions(values.filter(_ => _.length))
              onChange?.(values)
            }
          }}
        >
          {options.map(option => (
            <MenuItemOption
              key={`multiselect-menu-${option.value}`}
              value={option.value}
            >
              {option.label}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  )
}

MultiSelectMenu.displayName = 'MultiSelectMenu'

export interface MultiSelectMenuProps {
  label: string
  options: Array<{
    label: JSX.Element
    value: string
  }>
  onChange?(selectedValues: string[]): void
}

export default MultiSelectMenu
